<template>
    <Sheet v-loading="loading.actions['depgermanform']">
        <h2>{{routeTitle}}</h2>
        <!--<el-button @click="$router.push('/depgermanform')"
                   icon="el-icon-plus"
                   size="mini"
                   type="primary">
            新增
        </el-button>-->
        <el-button @click="refresh"
                   icon="el-icon-refresh"
                   size="mini">
            重新整理
        </el-button>
        <a class="btn_ods" style="margin-left: 10px;"
           :href="base.concat('api/german/getFormODS/').concat(queryInfo.text1)
                                          .concat(',').concat(queryInfo.id).concat(',')" target="_blank"
           v-show="totalItems>0">
            <i class="el-icon-document"></i> ODS文件
        </a>
        <!--<a class="btn_ods" style="margin-left: 10px;"
       :href="base.concat('api/german/getFormPDF/').concat(queryInfo.text1)
                                      .concat(',').concat(queryInfo.id).concat(',2')" target="_blank"
       v-show="totalItems>0">
        <i class="el-icon-document"></i> PDF文件
    </a>-->
        <table cellpadding="0" cellspacing="0" class="ncut-table-search" style="width: 100%; padding: 0.5em;">
            <tbody>
                <tr>
                    <td class="ncut-base-form-text" style="width:5em;">姓名：</td>
                    <td class="ncut-base-form-ipt" style="padding: 0.25em; width:5em;" tabindex="1">
                        <el-input v-model="queryInfo.text1" placeholder="請輸入姓名"></el-input>
                    </td>
                    <td class="ncut-base-form-text" style="width:5em;">學號：</td>
                    <td class="ncut-base-form-ipt" style="padding: 0.25em; width:6em;" tabindex="2">
                        <el-input v-model="queryInfo.text2" placeholder="請輸入學號"></el-input>
                    </td>
                    <td class="ncut-base-form-text" style="width:8em;">審核狀態：</td>
                    <td style="width:5.5em; ">
                        <el-select v-model="queryInfo.Review" placeholder="請選擇" tabindex="3">
                            <el-option v-for="item in review"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                            <el-option key="n00" label="無" :value="0" />
                        </el-select>
                    </td>

                    <td class="ncut-base-form-text" style="width:8em;">審核時間區間：</td>
                    <td>
                        <el-date-picker v-model="queryInfo.text3"
                                        :unlink-panels=true
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="開始日期"
                                        end-placeholder="结束日期"
                                        tabindex="4"
                                        :picker-options="pickerOptions1">
                        </el-date-picker>
                    </td>

                    <td style="padding: 0 0 0 3em;">
                        <el-button @click="refresh"
                                   icon="el-icon-refresh">
                            重新整理
                        </el-button>
                    </td>
                </tr>
            </tbody>
        </table>
        <el-table :data="pagedData"
                  :stripe="true"
                  empty-text="無表單"
                  height="620px"
                  row-key="id"
                  size="small">
            <el-table-column label="序號"
                             type="index"></el-table-column>
            <el-table-column label="學號"
                             prop="studentId"></el-table-column>
            <el-table-column label="班級"
                             prop="className"></el-table-column>
            <el-table-column label="姓名"
                             prop="name"></el-table-column>
            <el-table-column label="測驗類別"
                             prop="category"></el-table-column>
            <el-table-column label="核定金額"
                             prop="approved_amount"></el-table-column>
            <el-table-column label="是否審核通過"
                             prop="isReview"></el-table-column>
            <el-table-column>
                <template #default="{row}">
                    <el-button @click="onDetails(row)"
                               icon="el-icon-more"
                               size="mini"
                               type="info"></el-button>
                    <el-button @click="onUpdate(row)"
                               icon="el-icon-edit"
                               size="mini"
                               type="primary"></el-button>
                    <el-button @click="onRemove(row)"
                               icon="el-icon-delete"
                               size="mini"
                               type="danger"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="currentPage"
                       :page-size="pageSize"
                       :total="forms.length"
                       @current-change="page => pageChange(page, forms)"
                       background
                       layout="total, prev, pager, next"
                       style="margin-top: 10px;"></el-pagination>
        <el-dialog :visible.sync="showDialog"
                   @closed="onDialogClosed">
            <el-form :model="model"
                     :rules="rules"
                     label-width="120px"
                     ref="form"
                     v-loading="loading.actions['germanform/update']">
                <el-form-item label="身份證字號"
                              prop="iDno">
                    <el-input placeholder="請輸入身份證字號"
                              v-model="model.iDno"></el-input>
                </el-form-item>
                <el-form-item label="姓名"
                              prop="name">
                    <el-input placeholder="請輸入姓名"
                              v-model="model.name"></el-input>
                </el-form-item>
                <el-form-item label="部別"
                              prop="divisName">
                    <el-input placeholder="請輸入部別"
                              v-model="model.divisName"></el-input>
                </el-form-item>
                <el-form-item label="學號"
                              prop="studentId">
                    <el-input placeholder="請輸入學號"
                              v-model="model.studentId"></el-input>
                </el-form-item>
                <el-form-item label="系所"
                              prop="departmentName">
                    <el-input placeholder="請輸入系所"
                              v-model="model.departmentName"></el-input>
                </el-form-item>
                <el-form-item label="班級"
                              prop="className">
                    <el-input placeholder="請輸入班級"
                              v-model="model.className"></el-input>
                </el-form-item>
                <el-form-item label="電子郵件"
                              prop="email">
                    <el-input placeholder="請輸入電子郵件"
                              v-model="model.email"></el-input>
                </el-form-item>
                <el-form-item label="行動電話"
                              prop="mobiphone">
                    <el-input placeholder="請輸入行動電話"
                              v-model="model.mobiphone"></el-input>
                </el-form-item>
                <el-form-item label="戶籍地址"
                              prop="domicile">
                    <el-input placeholder="請輸入戶籍地址"
                              v-model="model.domicile"></el-input>
                </el-form-item>
                <el-form-item label="測驗類別"
                              prop="category">
                    <el-select v-model="model.category" placeholder="請選擇" tabindex="2">
                        <el-option v-for="item in categoryitem"
                                   :key="'n'.concat(item.no)"
                                   :label="item.codeName"
                                   :value="item.codeName">
                        </el-option>
                        <el-option key="n00" label="無" :value="0" :disabled="true" />
                    </el-select>
                </el-form-item>
                <el-form-item label="前測成績"
                              prop="pre_test">
                    <el-select v-model="model.pre_test" placeholder="請選擇" tabindex="2">
                        <el-option v-for="item in testitem"
                                   :key="'n'.concat(item.no)"
                                   :label="item.codeName"
                                   :value="item.codeName">
                        </el-option>
                        <el-option key="n00" label="無" :value="0" :disabled="true" />
                    </el-select>

                </el-form-item>
                <el-form-item :label="'前測日期'"
                               prop="pre_date">
                               <el-date-picker
                                placeholder="請輸入前測日期"
                                type="date"
                                v-model="model.pre_date"
                                format="yyyy-MM-dd"
                                ></el-date-picker>
                 </el-form-item>
                <el-form-item label="後測成績"
                              prop="post_test">
                    <el-select v-model="model.post_test" placeholder="請選擇" tabindex="2">
                        <el-option v-for="item in testitem"
                                   :key="'n'.concat(item.no)"
                                   :label="item.codeName"
                                   :value="item.codeName">
                        </el-option>
                        <el-option key="n00" label="無" :value="0" :disabled="true" />
                    </el-select>

                </el-form-item>
                <el-form-item :label="'後測日期'"
                               prop="post_date">
                               <el-date-picker
                                placeholder="請輸入後測日期"
                                type="date"
                                v-model="model.post_date"
                                format="yyyy-MM-dd"
                                ></el-date-picker>
                 </el-form-item>
                <el-form-item label="銀行名稱/銀行分行"
                              prop="bankname">
                    <el-input placeholder="請輸入銀行名稱/銀行分行"
                              v-model="model.bankname"></el-input>
                </el-form-item>
                <el-form-item label="銀行帳號"
                              prop="bankno">
                    <el-input placeholder="請輸入銀行帳號"
                              v-model="model.bankno"></el-input>
                </el-form-item>
                <el-form-item label="是否曾修習本校德語課程"
                              prop="iS_studyEnglish">
                    <el-radio-group v-model="model.iS_studyEnglish">
                        <el-radio :label="e.value"
                                  v-for="e in yesnos">
                            {{e.label}}
                        </el-radio>
                    </el-radio-group>
                    <span style="color:red;">
                        注意：若選「否」則不能申請
                    </span>
                </el-form-item>
                <el-form-item label="課程名稱"
                              prop="course">
                    <el-input placeholder="請輸入課程名稱"
                              v-model="model.course"></el-input>
                </el-form-item>
                <el-form-item label="等級"
                              prop="grade">
                    <el-select v-model="model.grade" placeholder="請選擇" tabindex="2">
                        <el-option v-for="item in gradeitem"
                                   :key="'n'.concat(item.no)"
                                   :label="item.codeName"
                                   :value="item.codeName">
                        </el-option>
                        <el-option key="n00" label="無" :value="0" :disabled="true" />
                    </el-select>

                </el-form-item>
                <el-form-item label="申請金額"
                              prop="application_money">
                    <el-input placeholder="申請金額"
                              v-model="model.application_money" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="是否申請報名費"
                              prop="iS_app_reg_fee">
                    <el-radio-group v-model="model.iS_app_reg_fee">
                        <el-radio :label="e.value"
                                  v-for="e in yesnos">
                            {{e.label}}
                        </el-radio>
                    </el-radio-group>
                    <span style="color:red;">
                        「每人限申請一次」
                    </span>
                </el-form-item>
                <el-form-item label="報名費金額"
                              prop="registery_fee">
                    <el-input placeholder="報名費金額"
                              v-model="model.registery_fee" :disabled="model.iS_app_reg_fee==='否'"></el-input>
                </el-form-item>
                <el-form-item label="是否通過審核"
                              prop="isReview">
                    <el-select v-model="model.isReview" @change="totalmoney()">
                        <el-option :label="g.label"
                                   :value="g.value"
                                   v-for="g in review"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="核定金額"
                              prop="approved_amount">
                    <el-input placeholder="核定金額"
                              v-model="model.approved_amount"></el-input>
                </el-form-item>
                <el-form-item label="審核未通過原因"
                              prop="review_content">
                    <el-input placeholder="審核未通過原因"
                              v-model="model.review_content"></el-input>
                </el-form-item>
                <el-form-item label="附件">
                    <el-upload :action="action"
                               :before-remove="handleBeforeRemove"
                               :before-upload="beforeUpload"
                               :data="dataOptions"
                               :headers="uploadHeaders"
                               :limit="4"
                               :on-error="onUploadError"
                               :on-exceed="onExceedLimit"
                               :on-success="onUploadSuccess"
                               ref="upload">
                        <el-button>選擇檔案</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                檔案不超過5MB
                            </div>
                        </template>
                    </el-upload>
                </el-form-item>
                <el-divider v-if="model.uploads.filter(u => !u.new).length">已上傳附件(點選刪除會直接刪除檔案)</el-divider>
                <el-tag :key="u.key"
                        closable
                        v-for="u in model.uploads.filter(u => !u.new)"
                        @close="onRemoveFile(u.key)"
                        @click="handleFile(u)"
                        style="margin-right: 5px;">
                    <span class="filename">{{u.name + u.extension}}</span>
                </el-tag>
            </el-form>
            <template #footer>
                <el-button @click="showDialog = false"
                           :loading="loading.actions['germanform/update']">
                    離開
                </el-button>
                <el-button @click="submit"
                           :loading="loading.actions['germanform/update']"
                           :disabled="model.iS_studyEnglish==='否'">
                    更新
                </el-button>
            </template>
        </el-dialog>
        <el-dialog :visible.sync="showDetailsDialog"
                   @closed="onshowDetailsDialogClosed">
            <el-form :data="pagedData"
                     :stripe="true"
                     disabled
                     empty-text="無表單"
                     height="620px"
                     row-key="id"
                     size="small">

                <el-form-item label="身份證字號"
                              prop="iDno">
                    <el-input placeholder="請輸入身份證字號"
                              v-model="model.iDno"></el-input>
                </el-form-item>
                <el-form-item label="姓名"
                              prop="name">
                    <el-input placeholder="請輸入姓名"
                              v-model="model.name"></el-input>
                </el-form-item>
                <el-form-item label="部別"
                              prop="divisName">
                    <el-input placeholder="請輸入部別"
                              v-model="model.divisName"></el-input>
                </el-form-item>
                <el-form-item label="學號"
                              prop="studentId">
                    <el-input placeholder="請輸入學號"
                              v-model="model.studentId"></el-input>
                </el-form-item>
                <el-form-item label="系所"
                              prop="departmentName">
                    <el-input placeholder="請輸入系所"
                              v-model="model.departmentName"></el-input>
                </el-form-item>
                <el-form-item label="班級"
                              prop="className">
                    <el-input placeholder="請輸入班級"
                              v-model="model.className"></el-input>
                </el-form-item>
                <el-form-item label="電子郵件"
                              prop="email">
                    <el-input placeholder="請輸入電子郵件"
                              v-model="model.email"></el-input>
                </el-form-item>
                <el-form-item label="行動電話"
                              prop="mobiphone">
                    <el-input placeholder="請輸入行動電話"
                              v-model="model.mobiphone"></el-input>
                </el-form-item>
                <el-form-item label="戶籍地址"
                              prop="domicile">
                    <el-input placeholder="請輸入戶籍地址"
                              v-model="model.domicile"></el-input>
                </el-form-item>
                <el-form-item label="測驗類別"
                              prop="category">
                    <el-input placeholder="請輸入測驗類別"
                              v-model="model.category"></el-input>
                </el-form-item>
                <el-form-item label="前測成績"
                              prop="pre_test">
                    <el-input placeholder="請輸入前測成績"
                              v-model="model.pre_test"></el-input>
                </el-form-item>
                <el-form-item :label="'前測日期'"
                               prop="pre_date"><br/>
                               <el-date-picker
                                placeholder="請輸入前測日期"
                                type="date"
                                v-model="model.pre_date"
                                format="yyyy-MM-dd"
                                ></el-date-picker>
                 </el-form-item>
                <el-form-item label="後測成績"
                              prop="post_test">
                    <el-input placeholder="請輸入後測成績"
                              v-model="model.post_test"></el-input>
                </el-form-item>
                <el-form-item :label="'後測日期'"
                               prop="post_date"><br/>
                               <el-date-picker
                                placeholder="請輸入後測日期"
                                type="date"
                                v-model="model.post_date"
                                format="yyyy-MM-dd"
                                ></el-date-picker>
                 </el-form-item>
                <el-form-item label="銀行名稱/銀行分行"
                              prop="bankname">
                    <el-input placeholder="請輸入銀行名稱/銀行分行"
                              v-model="model.bankname"></el-input>
                </el-form-item>
                <el-form-item label="銀行帳號"
                              prop="bankno">
                    <el-input placeholder="請輸入銀行帳號"
                              v-model="model.bankno"></el-input>
                </el-form-item>
                <el-form-item label="是否曾修習本校德語課程"
                              prop="iS_studyEnglish">
                    <el-radio-group v-model="model.iS_studyEnglish">
                        <el-radio :label="e.value"
                                  v-for="e in yesnos">
                            {{e.label}}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="課程名稱"
                              prop="course">
                    <el-input placeholder="請輸入課程名稱"
                              v-model="model.course"></el-input>
                </el-form-item>
                <el-form-item label="等級"
                              prop="grade">
                    <el-input placeholder="等級"
                              v-model="model.grade"></el-input>
                </el-form-item>
                <el-form-item label="申請金額"
                              prop="application_money">
                    <el-input placeholder="申請金額"
                              v-model="model.application_money"></el-input>
                </el-form-item>
                <el-form-item label="是否申請報名費"
                              prop="iS_app_reg_fee">
                    <el-radio-group v-model="model.iS_app_reg_fee">
                        <el-radio :label="e.value"
                                  v-for="e in yesnos">
                            {{e.label}}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="報名費金額"
                              prop="registery_fee">
                    <el-input placeholder="報名費金額"
                              v-model="model.registery_fee"></el-input>
                </el-form-item>
                <el-form-item label="是否通過審核"
                              prop="isReview">
                    <el-select v-model="model.isReview">
                        <el-option :label="g.label"
                                   :value="g.value"
                                   v-for="g in review"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="核定金額"
                              prop="approved_amount">
                    <el-input placeholder="核定金額"
                              v-model="model.approved_amount"></el-input>
                </el-form-item>
                <el-form-item label="審核未通過原因"
                              prop="review_content">
                    <el-input placeholder="審核未通過原因"
                              v-model="model.review_content"></el-input>
                </el-form-item>

                <el-divider v-if="model.uploads.filter(u => !u.new).length">已上傳附件(點選刪除會直接刪除檔案)</el-divider>
                <el-tag :key="u.key"
                        :closable="false"
                        v-for="u in model.uploads.filter(u => !u.new)"
                        @close="onRemoveFile(u.key)"
                        @click="handleFile(u)"
                        style="margin-right: 5px;">
                    <span class="filename">{{u.name + u.extension}}</span>
                </el-tag>
            </el-form>
            <template #footer>
                <el-button @click="showDetailsDialog = false">
                    離開
                </el-button>

            </template>
        </el-dialog>
        <el-dialog  v-dialogDrag
                   :visible.sync="showFileDialog"
                   @closed="onFileDialogClosed">
            <el-row>
                <el-col :span="20" style="padding: 0.5rem 0.5rem 0 0.5rem;">
                    <p class="arrow"
                       v-if="pdfDoc!=''">
                        頁數：<span class="turn" style="font-weight: bold;"
                                 :style="{'color': pBtnColor}"
                                 @click="changePdfPage(0)"><i class="el-icon-arrow-left"></i>{{$t('Preview_txt')}}</span>
                        {{currPdfPage}} / {{pageCount}}
                        <span class="turn" style="font-weight: bold;"
                              :style="{'color': nBtnColor}"
                              @click="changePdfPage(1)">{{$t('NextPage_txt')}}<i class="el-icon-arrow-right"></i></span>
                    </p>
                </el-col>
                <el-col :span="4" style="text-align: end; padding: 0.5rem 0.5rem 0 0.5rem;">
                    <el-button round icon="el-icon-close" size="mini"
                               @click="clearPdfFile()">關閉附件</el-button>
                </el-col>
            </el-row>
            <pdf scale="page-width" style="width:100%;margin:0.25em auto;border: 1px solid #BBCDC5 !important;"
                 :src="pdfDoc"
                 :page="currPdfPage"
                 @num-pages="pageCount=$event"
                 @page-loaded="currPdfPage=$event"></pdf>
        </el-dialog>
        <el-dialog v-dialogDrag
                   :visible.sync="showImgDialog"
                   @closed="onImgDialogClosed">
            <el-button round icon="el-icon-close" size="mini"
                       @click="clearImgFile()">關閉附件</el-button>
            <div class="viewer-wrapper" style="overflow:hidden;">
                <viewer :images="images"
                        @inited="inited"
                        class="viewer" ref="viewer">
                    <template slot-scope="scope">
                        <figure class="images">
                            <div class="image-wrapper" v-for="{source, thumbnail} in scope.images" :key="source">
                                <img class="image" style="width: 100%;"
                                     :src="thumbnail" :data-source="source" :alt="source.split('?image=').pop()" />
                            </div>
                        </figure>
                    </template>
                </viewer>
            </div>
        </el-dialog>
    </Sheet>
</template>

<script>
import {mapActions, mapState} from 'vuex';
    import moment from 'moment';
    import routeTitleMixin from './routeTitleMixin';
    import pagingMixin from '../pagingMixin';
    import UploadMixin from '../uploadMixin';
    import {base} from '../constants';
    import pdf from 'vue-pdf';

    const defaultModel = {
       iDno:'',
        name: '',
        divisName:'',
        studentId:'',
        departmentName:'',
        className:'',
        email: '',
        mobile: '',
        domicile:'',
        category:'',
        pre_test:'0',
        post_test:'0',
        bankname:'',
        bankno:'',
        iS_studyEnglish:null,
        course:'',
        grade:'',
        application_money:'0',
        iS_app_reg_fee:null,
        registery_fee:'0',
        isReview:null,
        approved_amount:'0',
        review_content:'',
        uploads: [],
    };
    export default {
        name: 'Table',
        mixins: [routeTitleMixin, pagingMixin, UploadMixin],
        data: () => ({
            //pageSize: 1,
            base: base,
            model: {...defaultModel},
            rules: {
                 name: [
                    {required: true, message: '請輸入姓名', trigger: 'blur'}
                ],
               category: [
                    {required: true, message: '請選擇測驗類別', trigger: 'blur'}
                ],
                 post_test: [
                    {required: true, message: '請輸入後測成績', trigger: 'blur'}
                ],
                post_date: [
                    {required: true, message: '請輸入後測日期', trigger: 'blur'}
                ],
                course: [
                    {required: true, message: '請輸入課程名稱', trigger: 'blur'}
                ],
                bankname: [
                    {required: true, message: '請輸入銀行名稱/銀行分行', trigger: 'blur'}
                ],
               bankno: [
                    {required: true, message: '請輸入請輸入銀行帳號', trigger: 'blur'}
                ],
              iS_studyEnglish: [
                    {required: true, message: '請選擇是否曾修習本校英語課程', trigger: 'blur'}
                ],
             grade: [
                    {required: true, message: '請選擇等級', trigger: 'blur'}
                ],
            application_money: [
                    {required: true, message: '請輸入請輸入申請金額', trigger: 'blur'}
                ],
            iS_app_reg_fee: [
                    {required: true, message: '請選擇是否申請報名費', trigger: 'blur'}
                ],

            },
            showDialog: false,
            showDetailsDialog:false,
            url: 'upload',
            queryInfo: {
                id  : 0,
                text1: ''
            },
            totalItems: 0,
            showFileDialog: false,
            pdfDoc: '',
            numPages: 0,
            currPdfPage: 1, // pdf文件页码
            pageCount: 0, // pdf文件总页数
            showImgDialog: false,
            images: [],
        }),
        components: {
            pdf
        },
        computed: {
            ...mapState('germanform', ['forms', 'selectedForm']),
            ...mapState('codeDt', ['codeList']),
            ...mapState(['loading']),
            yesnos() {
                return [
                    {label: '是', value: '是'},
                    {label: '否', value: '否'},
                ]
            },
            review() {
                return [
                    {label: '未審核', value: '未審核'},
                    {label: '通過', value: '通過'},
                    {label: '未通過', value: '未通過'},
                ]
            },
            pBtnColor () {
                return (this.currPdfPage==1?'#b2bbbe': '#207f4c');
            },
            nBtnColor () {
                return (this.currPdfPage==this.pageCount?'#b2bbbe': '#c1651a');
            }
        },
        methods: {
            ...mapActions('germanform',
                {
                    getAll: 'getFormsAction',
                    queryForm: 'getFormsByInfo',
                    get: 'getFormAction',
                    remove: 'removeFormAction',
                    update: 'updateFormAction'
                }
            ),
            ...mapActions('codeDt', {
                getCode: 'getCodeNo',
            }),
            ...mapActions({
                'removeFile': 'removeFileAction',
                'download': 'downloadFileAction',
            }),
            money: function() {

                          if (this.model.grade == "A1–新台幣捌佰元整"){
                                     this.model.application_money=800;
                              }
                           else if (this.model.grade == "A2–新台幣壹仟元整")
                           {
                                  this.model.application_money=1000;
                           }
                          else if (this.model.grade == "B1–新台幣壹仟叁佰元整")
                          {
                                  this.model.application_money=1300;
                          }
                          else if (this.model.grade == "B2–新台幣壹仟伍佰元整")
                          {
                                 this.model.application_money=1500;
                          }
                          else if (this.model.grade == "C1(含以上)–新台幣壹仟柒佰元整")
                          {
                                  this.model.application_money=1700;
                          }

                   },
    totalmoney: function() {
                  if (this.model.isReview == "通過")
                   {
                   var application_money=parseInt(this.model.application_money);
                   var registery_fee=parseInt(this.model.registery_fee);
                   var total=application_money+registery_fee;
                   this.model.approved_amount=total.toString();
                  }
                   },
            onFileDialogClosed(){
                this.showFileDialog = false;
                this.pdfDoc = '';
                this.currPdfPage = 1;
                this.pageCount = 0;
                this.numPages = 0;
            },
             onshowDetailsDialogClosed(){
                this.showDetailsDialog = false;
            },
            clearPdfFile(){
                this.onFileDialogClosed();
            },
            changePdfPage (val) {
                if (val === 0 && this.currPdfPage > 1) {
                    this.currPdfPage--;
                }
                if (val === 1 && this.currPdfPage < this.pageCount) {
                    this.currPdfPage++
                }
            },
            loadPdfHandler (e) {
             this.currPdfPage = 1;
            },
            setUrl(data) {
                const baseUrl = this.base.endsWith('/')
                   ? this.base.slice(0, -1)
                   : this.base;
 
                const tUrl =`${baseUrl}/api/upload/upload?key=${data.key}`;
 
                const contentType =(data.contentType || '').toLowerCase();
 
                console.log("contentType=", contentType);
                console.log("tUrl=", tUrl);
 
                // 先全部關閉
                this.showFileDialog = false;
                this.showImgDialog = false;
 
               // 圖片
               if (contentType.startsWith('image/')) {
 
               this.images = [{
               thumbnail: tUrl,
               source: tUrl
               }];
 
               this.showImgDialog = true;
 
               return;
              }
 
              // PDF
              if (contentType === 'application/pdf') {
 
                 this.currPdfPage = 1;
                 this.pageCount = 0;
                 this.numPages = 0;
 
                 this.pdfDoc = pdf.createLoadingTask(tUrl);
 
                 this.showFileDialog = true;
 
                 return;
               }
 
               this.$message.warning('不支援的檔案格式：${contentType}');
            },

            onImgDialogClosed(){
                this.showImgDialog = false;
                this.pdfDoc = '';
            },
            clearImgFile(){
                this.onImgDialogClosed();
            },
            inited (viewer) {
            this.$viewer = viewer
            },

            async onUpdate({id}) {
                const current = await this.get(id);
                if (current) {
                    this.showDialog = true;
                    this.model = {...current, sources: current.sources ? current.sources.split(',').map(s => parseInt(s)) : []};
                } else {
                    this.$message.warning('查無此資料');
                }
            },

           async onDetails({id}) {
                const current = await this.get(id);
                if (current) {
                    this.showDetailsDialog = true;
                    this.model = {...current, sources: current.sources ? current.sources.split(',').map(s => parseInt(s)) : []};
                } else {
                    this.$message.warning('查無此資料');
                }
            },

            async onRemove({id}) {
                try {
                    await this.$confirm('確定要刪除嗎?(刪除後將不能回復)', {
                        type: 'danger',
                    });
                    const {success} = await this.remove(id);
                    if (success) {
                        this.$message.success('刪除成功');
                    } else {
                        this.$message.warning('刪除失敗，請重試一次');
                    }
                } catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
            },

            async refresh() {
              //await this.getAll();
                await this.queryForm(this.queryInfo);
            },

            onUploadSuccess(res) {
                this.model.uploads.push({...res, new: true});
            },

            async handleBeforeRemove(file) {
                await this.beforeRemove(file);
                this.model.uploads = this.model.uploads.filter(f => f.uid !== file.uid);
            },

            async onRemoveFile(key){
                await this.removeFile({key});
                this.model.uploads = this.model.uploads.filter(u => u.key !== key);
            },

            async handleFile(u) {
                if (['.jpg','.pdf','.JPG','.jpeg'].includes(u.extension)) {
                    this.setUrl(u);
                } else {
                    this.onDownloadFile({key: u.key, fullName:u.name + u.extension });
                }
            },

            async onDownloadFile({key, fullName}){
                await this.download({key, fullName});
            },

            onDialogClosed(){
                this.reset();
            },

            submit() {
                const current = this.$refs['form'];
                current.validate(async valid => {
                    if (valid) {
                        const {success} = await this.update({
                            ...this.model,
                            uploads : this.model.uploads.filter(u => u.new),

                        });

                        if (success) {
                            this.$message({
                                type: 'success',
                                message: '表單送出成功'
                            });
                        } else {
                            this.$message({
                                type: 'danger',
                                message: '表單送出失敗，請重試一次'
                            });
                        }
                        this.reset();
                        this.showDialog = false;
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '驗證失敗，請檢查*欄位'
                        });
                    }
                })
            },

            reset() {
                const vm = this;
                this.$refs['form'].resetFields();
                this.$nextTick(() => vm.$refs['form'].clearValidate());
                this.model = {...defaultModel};
                this.$refs['upload'].clearFiles();
            },

            async query() {
                await this.queryForm(this.queryInfo);
/*                 if (success) {
                    this.totalItems = this.newsList.length;
                } */
            }
        },

        watch: {
            forms(current) {
                this.pagedData = this.pageData(current, 1);
                this.currentPage = 1;
                this.totalItems = (null != this.pagedData? this.pagedData.length: 0);
            }
        },

        async created() {
             var success = await this.getCode(6);

            if (success) {
                         this.categoryitem=success;}

         var  gradetemp = await this.getCode(8);
    if (gradetemp) {
                         this.gradeitem=gradetemp;}

     var  testtemp = await this.getCode(9);
    if (testtemp) {
                         this.testitem=testtemp;}
            await this.getAll();
        }
    }</script>

<style scoped>
    @import '../assets/styles/ncut.css';
    .filename{
        cursor: pointer;
    }
</style>